export enum ProvinceSortType {
    Id,
    Name,
    CountryName,
    IsDeleted
}
